/* eslint-disable */

import React from 'react';

import { ScrollView, StyleSheet, View } from 'react-native';
import Swiper from 'react-native-swiper';

const styles = StyleSheet.create({
  container: {
    backgroundColor: 'transparent',
    position: 'static',
  },
  wrapper: {
    backgroundColor: 'transparent',
  },
});

export default class SwiperWrapper extends Swiper {
  renderScrollView = (pages) => (
    <ScrollView
      ref="scrollView"
      {...this.props}
      style={{ overflowX: 'hidden' }}
      contentContainerStyle={[styles.wrapper, this.props.style, { overflow: 'hidden' }]}
      contentOffset={this.state.offset}
      onScrollBeginDrag={this.onScrollBegin}
      onMomentumScrollEnd={this.onScrollEnd}
      onScroll={this.onScroll}
      scrollEventThrottle={16}
    >
      {pages}
    </ScrollView>
  );

  render() {
    const state = this.state;
    const props = this.props;
    const children = props.children;
    const index = state.index;
    const total = state.total;
    const loop = props.loop;
    const dir = state.dir;
    const key = 0;

    let pages = [];
    const pageStyle = [{ width: state.width, height: state.height }, styles.slide];

    // For make infinite at least total > 1
    if (total > 1) {
      // Re-design a loop model for avoid img flickering
      pages = Object.keys(children);
      if (loop) {
        pages.unshift(total - 1);
        pages.push(0);
      }

      pages = pages.map((page, i) => (
        <View style={pageStyle} key={i}>
          {children[page]}
        </View>
      ));
    } else pages = <View style={pageStyle}>{children}</View>;

    return (
      <View
        style={[
          styles.container,
          {
            width: state.width,
            height: state.height,
          },
        ]}
      >
        {this.renderScrollView(pages)}
        {props.showsPagination &&
          (props.renderPagination
            ? this.props.renderPagination(state.index, state.total, this)
            : this.renderPagination())}
        {this.renderTitle()}
        {this.props.showsButtons && this.renderButtons()}
      </View>
    );
  }
}
